<template>
  <div class="m-1"
    :class="{
      'bg-gray-200': listIndex % 2 == 0,
      'bg-gray-100': listIndex % 2 == 1,
    }">
    <div class="grid grid-cols-12">
      <div class="p-2 col-span-2">
        <span class="w-full truncate text-sm">
          {{ auth0User.name }}
        </span>
      </div>
      <div class="p-2 col-span-2">
        <div class="w-full truncate text-sm">
          {{ auth0User.email }}
        </div>
      </div>
      <div class="p-2 col-span-2">
        <div class="w-full truncate text-sm">
          {{ auth0User.user_id }}
        </div>
      </div>
      <div class="col-span-2 flex flex-col w-full">
        <Group class="col-span-2"
          :userGroupOptions="userGroupOptions"
          :defaultValue="defaultGroups"
          v-model="formValues.groups"
        />
      </div>
      <div class="col-span-3 flex flex-col w-full">
        <ConfigSection
          :showHeader="false"
          :defaultValue="defaultConfig"
          v-model="formValues.config"
        />
      </div>
      <div class="flex flex-col col-span-1">
        <Button class="m-2 rounded-sm font-bold bg-gray-800 hover:bg-gray-400 text-center text-red-400 hover:text-red-200"
          v-if="showPortalUserError && portalUser === undefined">
          MISSING<br>
          PORTAL USER
        </Button>
        <Button
          color="gray"
          size="sm"
          @click="onEditEntryButtonPress">
          Edit Entry
        </Button>
        <Button
          color="gray"
          size="sm"
          @click="onDeleteEntryButtonPress">
          Delete Entry
        </Button>
      </div>
      <div class="flex flex-row col-span-10 items-center"
        v-if="showCommandExtension">
        <textarea class="m-2 p-2 w-[90%] h-14 text-sm"
          v-model="editCommand">
        </textarea>
        <Button class="w-32 m-2"
          color="blue"
          size="sm"
          @click="addUserQuery">
          Add to Query
        </Button>
        <XButton class="bg-orange-200 p-1 w-6 h-6 justify-center"
          @click="closeCommandExtension"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Group from './Group.vue'
import ConfigSection from './ConfigSection.vue'

import XButton from '../XButton.vue'
import Button from '../Button.vue'

import userManagementService from '../../services/pages/userManagement.js'

import { isEmpty } from 'lodash'

export default {
  props: {
    auth0User: Object,
    portalUser: Object,
    userGroupOptions: Array,
    listIndex: Number,
    defaultValue: Object,
    value: undefined,
    showPortalUserError: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    ConfigSection,
    Group,
    XButton,
    Button,
  },
  data() {
    return {
      formValues: {
        groups: [],
        config: {},
      },

      showCommandExtension: false,
      updateCommandType: undefined,
      editCommand: undefined,

      pendingKey: false,
      pendingValue: false,
    }
  },
  methods: {
    onEditEntryButtonPress() {
      this.showCommandExtension = true
      this.updateCommandType = 'edit'
      this.createEditEntry()
    },
    onDeleteEntryButtonPress() {
      this.showCommandExtension = true
      this.updateCommandType = 'delete'
      this.createDeleteEntry()
    },
    createEditEntry() {
      this.editCommand = userManagementService.createEditUserQuery(
        this.auth0User.user_id,
        this.auth0User.name,
        this.auth0User.email,
        this.formValues.groups,
        this.formValues.config.userConfig,
        this.formValues.config.appMetadata,
      )
    },
    createDeleteEntry() {
      this.editCommand = userManagementService.createDeleteUserQuery(
        this.auth0User.user_id
      )
    },
    addUserQuery() {
      if (this.editCommand) {
        this.$emit('addUserQuery', this.editCommand)

        this.editCommand = undefined
        this.showCommandExtension = false
      }
    },
    closeCommandExtension() {
      this.showCommandExtension = false
    },
    clearCommand() {
      this.editCommand = undefined
      this.showCommandExtension = false
    }
  },
  mounted() {
    // do nothing
  },
  computed: {
    defaultConfig() {
      let retConfig = {}
      if (this.auth0User) {
        retConfig.appMetadata = this.auth0User['app_metadata']['kanan']
      }
      if (this.portalUser) {
        retConfig.userConfig = this.portalUser['user_config'].reduce(
          (accum, curr) => {
            accum[curr.key] = curr.config
            return accum
          },
          {}
        )

        if (isEmpty(retConfig.userConfig)) {
          retConfig.userConfig = undefined
        }
      }

      return retConfig
    },
    defaultGroups() {
      if (this.portalUser) {
        return this.portalUser.groups.map(group => group.name)
      }
      else {
        return undefined
      }
    }
  },
  watch: {
    value(newValue) {
      this.formValues = newValue
    },
    'formValues.groups'() {
      if (this.showCommandExtension && this.updateCommandType === 'edit') {
        this.createEditEntry()
      }
    },
    'formValues.config': {
      handler() {
        if (this.showCommandExtension && this.updateCommandType === 'edit') {
          this.createEditEntry()
        }
      },
      deep: true,
    },
    portalUser() {
      this.clearCommand()
    },
    auth0User() {
      this.clearCommand()
    },
  }
}
</script>
